export const NEWS_FEATURE_KEY = 'news';
